import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tag, TagPeriod } from 'src/services/tag/Tag';
import { TagNode } from 'src/services/tag-tree/TagNode';
import { getTopLevelTag } from 'src/utils/getTopLevelTag';
import { TagNodeIconComponent } from '../tag-node-icon/tag-node-icon.component';
import { DialogService } from 'src/services/dialog/dialog.service';
import { PlannerComponent } from '../planner/planner.component';
import { DetailedTag } from 'src/services/tag/DetailedTag';
import { PrefundCurrencyPipe } from 'src/app/prefund-currency.pipe';
import { PeriodService } from 'src/app/services/period.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'tag-node-summary',
  standalone: true,
  imports: [
    CommonModule,
    TagNodeIconComponent,
    PrefundCurrencyPipe,
    MatTooltipModule,
  ],
  templateUrl: './tag-node-summary.component.html',
  styleUrls: ['./tag-node-summary.component.scss'],
})
export class TagNodeSummaryComponent {
  @Input()
  tags: DetailedTag[] = [];

  @Input()
  withCaptions = false;

  @Input()
  showForFixed = false;

  @Output()
  plannedAmountClicked = new EventEmitter<Tag>();

  @Input()
  node: TagNode | DetailedTag | null = null;

  constructor(
    private dialogService: DialogService,
    public periodService: PeriodService
  ) {}

  getTopLevelTag(tag: any) {
    return getTopLevelTag(tag, this.tags);
  }

  getTagPeriod(node: TagNode | DetailedTag | null): TagPeriod | null {
    const currentPeriod = this.periodService.current;
    const currentTagPeriod = node?.periods?.find(
      (p) =>
        p.period.year === currentPeriod.year &&
        p.period.month === currentPeriod.month
    );
    if (currentTagPeriod) {
      return currentTagPeriod;
    } else {
      return null;
    }
  }
}
